import {
  ExternalAttributes,
  FilterAttributes, FilterAttributesModel,
} from 'components/discovery/shared/search/typing/filter-attributes.js'
import typia from 'typia'
import { logValidationFailure } from 'components/shared/parsing/parsing.js'

export const CouldNotParseFilterAttributes = 'CouldNotParseAttributes' as const

export type FilterAttributesParseError = {
  type: typeof CouldNotParseFilterAttributes,
  error: any,
}

export class FilterAttributesParser {

  parseFilterAttributes = (response: unknown): FilterAttributes | FilterAttributesParseError => {
    const parsed = typia.validate<ExternalAttributes>(response)

    if (parsed.success) {
      return new FilterAttributesModel().with(parsed.data).parse()
    } else {
      logValidationFailure('filter attributes', parsed.errors)
      return {
        type: CouldNotParseFilterAttributes,
        error: parsed.errors
      }
    }
  }

  filterAttributeParseResultHasError = (
    parseResult: FilterAttributes | FilterAttributesParseError
  ): parseResult is FilterAttributesParseError => {
    return (parseResult as FilterAttributesParseError).error != null
  }
}
